import Config from "../config.js";
import _ from "lodash";

export function signIn(email, password, callback, failCallback) {
  fetch(`https://${Config.auth0.domain}/oauth/token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      grant_type: "password",
      username: email,
      password,
      scope: "openid profile email offline_access",
      client_id: Config.auth0.clientID,
    }),
  })
    .then((response) => response.json())
    .then((ret) => {
      callback(ret);
    })
    .catch((error) => {
      console.error("Error signing in with Auth0: " + error);
      failCallback("Error signing in with Auth0: " + error);
    });
}

export function getUserProfile(accessToken, callback, failCallback) {
  let auth = `Bearer ${accessToken}`;
  fetch(`https://${Config.auth0.domain}/userinfo`, {
    method: "GET",
    headers: {
      Authorization: auth,
    },
  })
    .then((response) => response.json())
    .then((ret) => {
      callback(ret);
    })
    .catch((error) => {
      console.error("Error getting user profile: " + error);
      failCallback(error);
    });
}

export function signUp(
  email,
  password,
  firstName,
  lastName,
  callback,
  failCallback
) {
  fetch(`https://${Config.auth0.domain}/dbconnections/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      client_id: Config.auth0.clientID,
      email,
      password,
      connection: "Username-Password-Authentication",
      user_metadata: { given_name: firstName, family_name: lastName },
    }),
  })
    .then((response) => response.json())
    .then((ret) => {
      callback(ret);
    })
    .catch((error) => {
      console.error("Error signing up with Auth0: " + error);
      failCallback(error);
    });
}

export function changePassword(email, callback, failCallback) {
  fetch(`https://${Config.auth0.domain}/dbconnections/change_password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      client_id: Config.auth0.clientID,
      email,
      connection: "Username-Password-Authentication",
    }),
  })
    .then((ret) => {
      callback(ret);
    })
    .catch((error) => {
      console.error("Error changing password with Auth0: " + error);
      failCallback(error);
    });
}



// WEBPACK FOOTER //
// ./src/services/auth.js